import { Component, ViewChild, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform } from 'ionic-angular';
import { StorageProvider } from '../../providers/storage/storage';
import { Notification } from 'interfaces/notification.model';
import { NotificationProvider } from '../../providers/notification/notification';
import { HelperProvider } from '../../providers/helper/helper';

/**
 * Generated class for the NotificationsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-notifications',
  templateUrl: 'notifications.html',
})
export class NotificationsPage {

  @ViewChild('myHeader') ionHeader: ElementRef;

  notifications: Notification[];
  showNotifDetails: boolean;
  selectedNotif: Notification;
  isIosPlatform: boolean;

  constructor(public navCtrl: NavController, public navParams: NavParams, private storageService: StorageProvider, public notificationService: NotificationProvider, public platform: Platform, public helperService: HelperProvider) {
    this.notifications = [];
    this.selectedNotif = null;
    // this.isIosPlatform = this.platform.is('ios');
    //[VP - 27/01/2021] Use custom function to detect iOS because of ionic bug: https://github.com/ionic-team/ionic-v3/issues/1104
    this.isIosPlatform = this.helperService.isIOS();
  }

  ionViewDidLoad() {
    this.getNotifications();
  }

  getNotifications(){
    this.notificationService.getNotifications().then((notifs:Notification[]) => {
      this.notifications = notifs;
      if(this.notifications.length > 0){
        this.selectedNotif = this.notifications[0];
      }
    });
  }

  showNotification(notification, event){
    event.stopPropagation();
    this.selectedNotif = notification;
    this.showNotifDetails = !this.showNotifDetails;
  }

  setActiveNotif(notification){
    let activeClass = "";
    if(notification != null && (this.selectedNotif.NotificationId == notification.NotificationId)){
      activeClass = "active";
    }
    return activeClass;
  }

  markAsRead(notification){
    notification.isRead = !notification.isRead;
    this.storageService.setDataStorage("notifications", this.notifications);
  }

  markAllAsRead(){
    if(this.notifications.length > 0){
      this.notifications.forEach(notif =>{
        notif.isRead = true;
      });
      this.storageService.setDataStorage("notifications", this.notifications);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/notifications/notifications.ts